exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.highlight {\n  color: #fcad02f8;\n  font-weight: bold;\n}\n", ""]);

// exports
